import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        resdata: {},
        avatar:"",
        searchKey:{},  //群聊别人发我
        searchKey2:{}, //会话别人发我
        searchKey3:{}, //会话我发别人
        searchKey4:[], //小红点（会话
        searchKey5:[], //小红点（群聊
        searchKey6:[], //小红点（标题3
    },
    getters: {

    },
    mutations: {
        // 1.群聊别人发我
        changeSearchKey(state,value){
            state.searchKey = value
        },
        // 2.会话别人发我
        changeSearchKey2(state,value){
            state.searchKey2 = value
        },
        // 3.会话我发别人
        changeSearchKey3(state,value){
            state.searchKey3 = value
        },
        // 3.小红点（会话
        changeSearchKey4(state,value){
            state.searchKey4 = value
        },
        // 4.小红点（群聊
        changeSearchKey5(state,value){
            state.searchKey5 = value
        },
        // 5.小红点（标题3
        changeSearchKey6(state,value){
            state.searchKey6 = value
        },

        qipao(state, resdata) {
            if(resdata.system){
                state.resdata = resdata.system.badge.todo
            }
        },
        setImg(state,val){
           state.avatar = val+`?t=${Math.random()}`
           localStorage.setItem('Appavatar',JSON.stringify(state.avatar))
        },
        
},
actions: {         //异步修改数据仓库
    //群聊别人发我
    setSearchKey(context,value){  
        context.commit('changeSearchKey',value)
    },
    //会话别人发我
    setSearchKey2(context,value){  
        context.commit('changeSearchKey2',value)
    },
    //会话我发别人
    setSearchKey3(context,value){  
        context.commit('changeSearchKey3',value)
    },
    //小红点（会话
    setSearchKey4(context,value){  
        context.commit('changeSearchKey4',value)
    },
    //小红点（群聊
    setSearchKey5(context,value){  
        context.commit('changeSearchKey5',value)
    },
    //小红点（标题3
    setSearchKey6(context,value){  
        context.commit('changeSearchKey6',value)
    },
   }


})



// WEBPACK FOOTER //
// ./src/store/index.js